/**
 * Equalizes the height of tiles within each grid container
 * This ensures tiles have the same height while preserving the margin-top: auto spacing
 */
const equalizeGridTileHeights = () => {
  const $tileContainers = document.querySelectorAll(
    ".jiffytransfers-landing-v2-popular-dtf-transfers-section__tiles"
  );

  $tileContainers.forEach(container => {
    const $tiles = container.querySelectorAll(
      ".jiffytransfers-landing-v2-popular-dtf-transfers-section__tile"
    );

    if ($tiles.length === 0) return;

    $tiles.forEach(tile => {
      const tileElement = tile;
      tileElement.style.height = "auto";
    });

    // Get the maximum height from all $tiles
    const maxHeight = Math.max(...Array.from($tiles).map(tile => tile.offsetHeight));

    // Apply the max height to all $tiles
    $tiles.forEach(tile => {
      const tileElement = tile;
      tileElement.style.height = `${maxHeight}px`;
    });
  });
};

/**
 * Sets up tile height equalization
 * Runs once after the UI is painted
 */
export const setupTileHeightEqualization = () => {
  requestAnimationFrame(() => {
    equalizeGridTileHeights();
  });
};

export default equalizeGridTileHeights;
